import React from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Input,
  InputGroup,
  CardTitle,
} from "reactstrap"
export default function Statistics(props) {
  return (
    <Col lg={6}>
      <Card>
        <CardBody>
          <CardTitle className="mb-4">Statistics</CardTitle>

          <Form>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Cash Balance</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {Number(parseFloat(props?.userData?.cash_balance ?? 0)?.toFixed(2)).toLocaleString('en-GB')}
                </p>
              </Col>
            </div>

            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Bonus Balance</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {Number(parseFloat(props?.userData?.bonus_balance ?? 0)?.toFixed(2)).toLocaleString('en-GB')}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Signup Freebet Balance</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {Number(
                    parseFloat(props?.userData?.signup_freebet ?? 0)?.toFixed(2)
                  ).toLocaleString("en-GB")}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Pending Bets</Label>
              </Col>
              <Col xs={6} sm={8} md={6} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {" "}
                  {Number(parseFloat(props?.userData?.pending_bets ?? 0)?.toFixed(2)).toLocaleString('en-GB')}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">YTD Sales</Label>
              </Col>
              <Col xs={6} sm={8} md={6} lg={6}>
                <p className="text-muted fw-medium col-form-label">{Number(parseFloat(props?.userData?.current_year_stake ?? 0)?.toFixed(2)).toLocaleString('en-GB')}</p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">LT Sales</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">{Number(parseFloat(props?.userData?.registration_stake ?? 0)?.toFixed(2)).toLocaleString('en-GB')}</p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Average Bet</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {" "}
                  {Number(props?.userData?.average_bets.toFixed(2)).toLocaleString('en-GB')}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Last Bet</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {" "}
                  {Number(parseFloat(props?.userData?.last_bet ?? 0)?.toFixed(2)).toLocaleString('en-GB')}
                </p>
              </Col>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Col>
  )
}
